/* Studio Spice – Brand v1.0 · behaviour layer
   1) product-line accent dot on cards (P14)
   2) review sections: demo content in preview, auto-hide placeholders otherwise (P4)
   Data comes from window.SSBrand (snippet brand-v1.liquid). */
(function () {
  var B = window.SSBrand || {};
  var d = document;
  var PH = /add your review here|alex johnson|product name|\$\s?29[.,]99/i;

  var SAMPLE_NAMES = ['Laura M.', 'Sofia R.', 'Emma V.', 'Noor B.', 'Julia K.', 'Marta G.', 'Inés P.', 'Lotte D.'];
  var SAMPLE_TEXT = [
    'A calm cup after dinner has become my evening ritual. Warm, gentle and not too spicy.',
    'Lovely, honest ingredients and you can taste the quality. The pouch looks beautiful on my shelf.',
    'I brew a pot in the morning and sip it through the day. Earthy, smooth and comforting.',
    'Beautifully packed and quick delivery. The aroma when you open the pouch is wonderful.',
    'My favourite moment of the day now. Simple to prepare and it tastes like a real treat.',
    'Great flavour, not bitter at all. I like knowing exactly where it comes from.'
  ];

  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  function handleFrom(href) { var m = (href || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }
  function addDot(target, handle) {
    var acc = B.accents && B.accents[handle];
    if (!acc || !target || target.querySelector('.ss-dot')) return;
    var s = d.createElement('span'); s.className = 'ss-dot'; s.setAttribute('aria-hidden', 'true');
    s.style.setProperty('--ss-dot', acc); target.insertBefore(s, target.firstChild);
  }
  function hideSection(el) { var s = el.closest('.shopify-section'); if (s) s.style.display = 'none'; }

  function accents() {
    d.querySelectorAll('.product-card').forEach(function (c) {
      var a = c.querySelector('a[href*="/products/"]');
      var h = handleFrom(c.getAttribute('data-product-url')) || handleFrom(a && a.getAttribute('href'));
      addDot(c.querySelector('.fc-product-title'), h);
    });
    d.querySelectorAll('[class^="ai-product-title-link-"]').forEach(function (a) {
      addDot(a, handleFrom(a.getAttribute('href')));
    });
  }

  function reviews() {
    /* Home testimonial slider */
    var trs = d.querySelectorAll('.trs-card');
    var trsPH = Array.prototype.some.call(trs, function (c) { return PH.test(c.textContent); });
    if (trs.length && trsPH) {
      if (B.demo) {
        trs.forEach(function (c, i) {
          var desc = c.querySelector('.trs-card-description');
          if (desc && PH.test(desc.textContent)) desc.textContent = SAMPLE_TEXT[i % SAMPLE_TEXT.length];
        });
      } else { hideSection(trs[0]); }
    }

    /* PDP customer review slider */
    var crs = d.querySelectorAll('.crs-card');
    var crsPH = Array.prototype.some.call(crs, function (c) { return PH.test(c.textContent); });
    if (crs.length && crsPH) {
      if (B.demo && B.product) {
        crs.forEach(function (c, i) {
          var n = c.querySelector('.crs-customer-name'); if (n) n.textContent = SAMPLE_NAMES[i % SAMPLE_NAMES.length];
          var t = c.querySelector('.crs-review-text'); if (t) t.innerHTML = '<p>' + SAMPLE_TEXT[(i + 2) % SAMPLE_TEXT.length] + '</p>';
          var pn = c.querySelector('.crs-product-name'); if (pn) pn.textContent = B.product.title;
          var pp = c.querySelector('.crs-product-price'); if (pp) pp.textContent = B.product.price;
          var pi = c.querySelector('.crs-product-image');
          if (pi && B.product.image) pi.innerHTML = '<img src="' + B.product.image + '" alt="" width="80" height="80" loading="lazy">';
        });
      } else { hideSection(crs[0]); }
    }
    d.documentElement.classList.add('ss-reviews-ready');
  }

  ready(function () {
    try { accents(); } catch (e) {}
    try { reviews(); } catch (e) { d.documentElement.classList.add('ss-reviews-ready'); }
    /* collection grid re-renders cards on filter/sort: re-apply dots */
    var grid = d.querySelector('.collection-grid-section');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { accents(); }).observe(grid, { childList: true, subtree: true });
    }
  });
})();
